import React from 'react';

import { cn } from '../lib/utils';

export interface TableProps extends React.TableHTMLAttributes<HTMLTableElement> {
  /** Concise accessible purpose when a visible caption is not appropriate. */
  accessibleName?: string;
}

/** Canonical semantic table root for intentionally authored native tables. */
export const Table = React.forwardRef<HTMLTableElement, TableProps>(
  ({ className, accessibleName, ...props }, ref) => (
    <table
      ref={ref}
      className={cn('w-full border-collapse text-left', className)}
      aria-label={accessibleName}
      data-table-root="true"
      {...props}
    />
  ),
);

Table.displayName = 'Table';
